import { useEffect } from 'react'

import * as t from '../i18n/pt-BR'
import { appConfig } from './config'

/** Título da aba: "Página | Produto". Sem página, só o nome do produto. */
export function usePageTitle(page?: string): void {
  useEffect(() => {
    document.title = page ? t.common.pageTitle(page, appConfig.appName) : appConfig.appName
  }, [page])
}
